module.exports = __webpack_public_path__ + "img/balkon.ef360acf.jpg";